import React from 'react';
import { ProductionsShowCard } from './ProductionsShowCard';

export const ProductionsShowPage = ({ id }) => {
  return (
    <ProductionsShowCard id={id} />
  );
};